import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { CostsStackParamList } from "../../types";
import CostsOverviewConceptScreen from "../costs/suggested/CostsOverviewConceptScreen";
import InsuranceScreen from "../costs/InsuranceScreen";
import EmployerBenefitsScreen from "../costs/EmployerBenefitsScreen";
import FinancingScreen from "../costs/FinancingScreen";
import GrantsScreen from "../costs/GrantsScreen";
import GrantDetailScreen from "../costs/GrantDetailScreen";
import PaymentsClaimsScreen from "../costs/PaymentsClaimsScreen";
import TaxDeductionsScreen from "../costs/TaxDeductionsScreen";
import TaxReviewScreen from "../costs/TaxReviewScreen";
import GlossaryScreen from "../costs/GlossaryScreen";

const Stack = createNativeStackNavigator<CostsStackParamList>();

export default function CostsNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen
        name="CostsOverview"
        component={CostsOverviewConceptScreen}
      />
      <Stack.Screen name="Insurance" component={InsuranceScreen} />
      <Stack.Screen
        name="EmployerBenefits"
        component={EmployerBenefitsScreen}
      />
      <Stack.Screen name="Financing" component={FinancingScreen} />
      <Stack.Screen name="Grants" component={GrantsScreen} />
      <Stack.Screen name="GrantDetail" component={GrantDetailScreen} />
      <Stack.Screen name="Payments" component={PaymentsClaimsScreen} />
      <Stack.Screen name="TaxDeductions" component={TaxDeductionsScreen} />
      <Stack.Screen name="TaxReview" component={TaxReviewScreen} />
      <Stack.Screen name="Glossary" component={GlossaryScreen} />
    </Stack.Navigator>
  );
}
